/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
export type AdminsDTO = {
  createdAt: string;
  email: string;
  firstName: string;
  id: string;
  img_url: string;
  lastName: string;
  updatedAt: string;
};

interface StudentsData {
  data: AdminsDTO[];
  metaData: MetaData;
}

interface Response {
  data?: StudentsData;
  error?: ApiError;
}

interface GetAdminsParams {
  page: number;
  limit: number;
}

export const GetAdminsList = async ({
  page,
  limit,
}: GetAdminsParams): Promise<Response> => {
  try {
    const response = await axios.get(`/admin/all`, {
      params: { page, limit },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
